import { render, staticRenderFns } from "./RelatorioNotaFinal.vue?vue&type=template&id=a8131e4e&scoped=true"
import script from "./RelatorioNotaFinal.vue?vue&type=script&lang=js"
export * from "./RelatorioNotaFinal.vue?vue&type=script&lang=js"
import style0 from "./RelatorioNotaFinal.vue?vue&type=style&index=0&id=a8131e4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8131e4e",
  null
  
)

export default component.exports